import MinerAddress from './MinerAddress';

export default MinerAddress;
